module.exports = {
      id: "ic-parabolic-usage",
      viewBox: "0 0 25 24",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#ic-parabolic-usage",
      toString: function () {
        return this.url;
      }
    }